import PipelineBrand from './pipeline-brand';
import PipelineCashBack from './pipeline-cashBack';
import PipelineFreeSubsidy from './pipeline-free-subsidy';
import PipelineGoodsHorizontal from './pipeline-goodsHorizontal';
import PipelineGoodsRecommend from './pipeline-goodsRecommend'
import PipelineHotspots from './pipeline-hotspots'
import PipelineImage from './pipeline-image'
import PipelineImgList from './pipeline-imgList';
import PipelineNavigation from "./pipeline-navigation";
import PipelineProduct from './pipeline-product';
import PipelineProductCustomize from './pipeline-productCustomize';
import PipelineRank from './pipeline-rank';
import PipelineRecommend from './pipeline-recommend';
import PipelineRecommendTopGoods from './pipeline-recommendTopGoods';
import PipelineSubsidy from "./pipeline-subsidy";
import PipelineVideo from "./pipeline-video";
import PipelineVote from './pipeline-vote';
import PipelineImgAnimate from './pipeline-imgAnimate';
import PipelineImgHotMap from './pipeline-imgHotMap';
import PipelineProductSwiper from './pipeline-productSwiper';
import PipelineCommunity from './pipeline-community';
import PipelineCashBackAct from './pipeline-cashBackAct';
import PipelineCashBackActNew from './pipeline-cashBackActNew';
import PipelineImgs from './pipeline-imgs';
import PipelineNavBar from './pipeline-navBar';
import PipelineProductList from './pipeline-productList';
import PipelineRankList from './pipeline-rankList';
import PipelineSubsidyList from './pipeline-subsidyList';
import PipelineCommunityArticle from './pipeline-communityArticle';
import PipelineCommunityArticleScroll from './pipeline-communityArticleScroll';
import PipelinePkRank from './pipeline-pkRank';
import PipelineImgListScroll from './pipeline-imgListScroll';
import PipelineSuctionBottomBtns from './pipeline-suctionBottomBtns';
import PipelineSquare from './pipeline-square';
import PipelineSpikeProduct from './pipeline-spikeProduct';
import PipelineGames from './pipeline-games';
import pipelineImgSwiper from './pipeline-imgSwiper';
import pipelineSearchCard from './pipeline-searchCard';
import pipelineSearchSwiper from './pipeline-searchSwiper';
import pipelineSearchSlogan from './pipeline-searchSlogan';
import pipelineSearchProduct from './pipeline-searchProduct';
import pipelineSpringFestivalFloor from './pipeline-springFestivalFloor';
import PipelineSenceFloor from './pipeline-sence-floor';
import PipelineSenceSwiper from './pipeline-sence-swiper';
import PipelineSenceTab from './pipeline-sence-tab';
import PipelineRecommendFeeds from './pipeline-recommend-feeds';
import PipelineModal from './pipeline-modal';
import PipelineLottery from './pipeline-lottery';
import PipelineCommunityShaiwu from './pipeline-communityShaiwu';
import PipelineTab from './pipeline-tab';
import PipelineRankCollection from './pipeline-rankCollection';
import PipelineFloor from './pipeline-floor';
import PipelineDateRange from './pipeline-date-range';
import PipelineMenuBar from './pipeline-menuBar';
import PipelineCheckAppProduct from './pipeline-checkAppProduct';
import PipelineCutPriceGoodsList from './pipeline-cutPriceGoodsList';
import pipelineDepreciateTop from './pipeline-depreciateTop';
import PipelineDouble11Floor from './pipeline-double11Floor';
import PipelineButton from './pipeline-button';
import PipelinePriceTrend from './pipeline-priceTrend';
import PipelineCheckAppDetail from './pipeline-checkAppDetail';
import PipelineTextarea from './pipeline-textarea';
import PipelineImageText from './pipeline-imageText';
import pipelineInteractMessage from './pipeline-interactMessage';
import pipelineIntelligent from './pipeline-intelligent';
import PipelineGoodsInfoPreview from './pipeline-goodsInfoPreview';
import pipelineCommunityCustom from './pipeline-communityCustom';
import pipelineHeadlines from './pipeline-headlines';
import pipelineProductCollection from './pipeline-productCollection';
import PipelineProductGather from './pipeline-productGather';
import PipelineSchoolLottery from './pipeline-schoolLottery';
import PipelineCommunityVote from './pipeline-communityVote';
import PipelineProductLayout3 from './pipeline-productLayout3';
import PipelineSideBar from './pipeline-sideBar';
import PipelineTimedLottery from './pipeline-timedLottery';
import PipelineHotSellRankList from './pipeline-hotSellRankList';
import PipelineFloorBarTitle from './pipeline-floorBarTitle';



export default {
  'pipeline-brand': PipelineBrand,
  'pipeline-cashBack': PipelineCashBack,
  'pipeline-free-subsidy': PipelineFreeSubsidy,
  'pipeline-goodsHorizontal': PipelineGoodsHorizontal,
  'pipeline-goodsRecommend': PipelineGoodsRecommend,
  'pipeline-hotspots': PipelineHotspots,
  'pipeline-image': PipelineImage,
  'pipeline-imgList': PipelineImgList,
  'pipeline-navigation': PipelineNavigation,
  'pipeline-product': PipelineProduct,
  'pipeline-productCustomize': PipelineProductCustomize,
  'pipeline-rank': PipelineRank,
  'pipeline-recommend': PipelineRecommend,
  'pipeline-recommendTopGoods': PipelineRecommendTopGoods,
  'pipeline-subsidy': PipelineSubsidy,
  'pipeline-video': PipelineVideo,
  'pipeline-vote': PipelineVote,
  'pipeline-imgAnimate': PipelineImgAnimate,
  'pipeline-imgHotMap': PipelineImgHotMap,
  'pipeline-productSwiper': PipelineProductSwiper,
  'pipeline-community': PipelineCommunity,
  'pipeline-cashBackAct': PipelineCashBackAct,
  'pipeline-cashBackActNew': PipelineCashBackActNew,
  'pipeline-imgs': PipelineImgs,
  'pipeline-navBar': PipelineNavBar,
  'pipeline-productList': PipelineProductList,
  'pipeline-rankList': PipelineRankList,
  'pipeline-subsidyList': PipelineSubsidyList,
  'pipeline-communityArticle': PipelineCommunityArticle,
  'pipeline-communityArticleScroll': PipelineCommunityArticleScroll,
  'pipeline-pkRank': PipelinePkRank,
  'pipeline-imgListScroll': PipelineImgListScroll,
  'pipeline-suctionBottomBtns': PipelineSuctionBottomBtns,
  'pipeline-square': PipelineSquare,
  'pipeline-spikeProduct': PipelineSpikeProduct,
  'pipeline-games': PipelineGames,
  'pipeline-imgSwiper': pipelineImgSwiper,
  'pipeline-searchCard': pipelineSearchCard,
  'pipeline-searchSwiper': pipelineSearchSwiper,
  'pipeline-searchSlogan': pipelineSearchSlogan,
  'pipeline-searchProduct': pipelineSearchProduct,
  'pipeline-springFestivalFloor': pipelineSpringFestivalFloor,
  'pipeline-sence-floor': PipelineSenceFloor,
  'pipeline-sence-swiper': PipelineSenceSwiper,
  'pipeline-sence-tab': PipelineSenceTab,
  'pipeline-recommend-feeds': PipelineRecommendFeeds,
  'pipeline-modal': PipelineModal,
  'pipeline-lottery': PipelineLottery,
  'pipeline-communityShaiwu': PipelineCommunityShaiwu,
  'pipeline-tab': PipelineTab,
  'pipeline-rankCollection': PipelineRankCollection,
  'pipeline-floor': PipelineFloor,
  'pipeline-date-range': PipelineDateRange,
  'pipeline-menuBar': PipelineMenuBar,
  'pipeline-checkAppProduct': PipelineCheckAppProduct,
  'pipeline-cutPriceGoodsList': PipelineCutPriceGoodsList,
  'pipeline-depreciateTop': pipelineDepreciateTop,
  'pipeline-double11Floor': PipelineDouble11Floor,
  'pipeline-button': PipelineButton,
  'pipeline-priceTrend': PipelinePriceTrend,
  'pipeline-checkAppDetail': PipelineCheckAppDetail,
  'pipeline-textarea': PipelineTextarea,
  'pipeline-imageText': PipelineImageText,
  'pipeline-interactMessage': pipelineInteractMessage,
  'pipeline-intelligent': pipelineIntelligent,
  'pipeline-goodsInfoPreview': PipelineGoodsInfoPreview,
  'pipeline-communityCustom': pipelineCommunityCustom,
  'pipeline-headlines': pipelineHeadlines,
  'pipeline-productCollection': pipelineProductCollection,
  'pipeline-productGather': PipelineProductGather,
  'pipeline-schoolLottery': PipelineSchoolLottery,
  'pipeline-communityVote': PipelineCommunityVote,
  'pipeline-productLayout3': PipelineProductLayout3,
  'pipeline-sideBar': PipelineSideBar,
  'pipeline-timedLottery': PipelineTimedLottery,
  'pipeline-hotSellRankList': PipelineHotSellRankList,
  'pipeline-floorBarTitle': PipelineFloorBarTitle,
}


// WEBPACK FOOTER //
// ./components/index.js